import React from 'react';
import Dice from './dice.svg';

const DiceIcon = ({height='20px', width='20px', color='white', className=''}) => {
    return <Dice height={height} width={width} color={color} aria-label="Dice" className={className}/>;
}

export default DiceIcon;